const ip_blacklist = {
	deblock_dialog: {
		description: "Weet u zeker dat u IP adres <strong>{{ip_address}}</strong> wilt deblokkeren?",
		title: "IP adres deblokkeren",
	},
	on_success: "IP adres succesvol gedeblokkeerd",
	table: {
		created_at: "Geblokkeerd op",
		failures: "Mislukte inlogpogingen",
		id: "ID",
		ip_address: "IP adres",
		no_items: "Geen items gevonden",
		username: "Gebruikersnaam",
	},
	title: "IP blacklist",
};

export default ip_blacklist;
